import { gsap } from 'gsap/gsap-core';
import { SplitText } from 'gsap/SplitText';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Class representing animations using GSAP.
 */
export class Animations {
    /**
     * Constructs an Animations object.
     */
    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        this.hero();
        this.animations();
        this.parallax();
    }

    parallax() {
        const images = $('.parallax img');

        images.each(function() {
            const image = $(this);

            gsap.to(image, {
                yPercent: -25,
                ease: 'none',
                scrollTrigger: {
                    trigger: image[0],
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });
    }

    animations() {
        let sections = gsap.utils.toArray('section');

        if(!sections.length) {
            return false;
        }

        sections.forEach(section => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'top 85%',
                    toggleActions: 'play',
                }
            })
            
            /**
             * Fade in.
             */
            let fade = $('.fade-in', section);
            
            if(fade.length) {
                tl.from($('.fade-in > *', section), {
                    yPercent: 10,
                    duration: 1,
                    opacity: 0,
                    stagger: 0.25,
                    ease: 'power4.out',
                }, 0.5)
            }
        });
    }

    hero() {
        let section = $('section.hero');
        if (!section.length) {
            return false;
        }

        // Active slide only – copy/CTA layers swap with the carousel; initial state is slide 0.
        let h1 = $('.hero__content-slide.is-active h1', section).first(),
            description = $('.hero__content-slide.is-active .hero__copy', section),
            button = $('.hero__content-slide.is-active .hero__buttons', section),
            figure = $('figure', section),
            overlay = $('.overlay span', figure),
            image = $('img', figure),
            firstBgSlideInner = $('.hero__bg-slide-inner', section).eq(0);

        let words = [];
        if (h1.length) {
            let split = new SplitText(h1, {
                type: 'lines, words',
                linesClass: 'parent',
                wordsClass: 'child'
            });
            gsap.set(split.lines, { display: 'inline-block' });
            words = split.words;
        }

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 85%',
                toggleActions: 'play',
            }
        });

        tl.from([description, button], {
            y: '100%',
            opacity: 0,
            ease: 'power2.out',
            stagger: 0.2,
            duration: 0.75
        }, 0);

        if (words.length) {
            tl.from(words, {
                y: '100%',
                opacity: 0,
                ease: 'power2.out',
                stagger: 0.2,
                duration: 0.75
            }, 0);
        }

        /**
         * Zoom-out effect for the first hero background image (inner only – overlay stays fixed).
         */
        if (firstBgSlideInner && firstBgSlideInner.length) {
            tl.fromTo(firstBgSlideInner, {
                scale: 1.1
            }, {
                scale: 1,
                duration: 3,
                ease: 'power2.out'
            }, 0);
        }

        tl.from(overlay, {
            duration: 1,
            width: 0,
            stagger: 0.2,
            ease: 'power4.out',
        }, 0).to(overlay, {
            duration: 1,
            scaleX: 0,
            transformOrigin: 'right',
            ease: 'power4.out',
        }, 1).from(image, {
            opacity: 0,
            scale: 1.25,
            duration: 1.5,
            ease: 'power4.out',
        }, 1)
    }
}